import BaseModelAPI from '../BaseModelAPI';

export default class ContractStatusList extends BaseModelAPI {

	static entity = 'contractstatuslist'
	static entityName = 'contractstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
